import { FC, memo, useCallback } from "react";
import isEqual from "lodash/isEqual";
import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import map from "lodash/map";
import { CityOutput } from "~@/api/models";

type CitySelectorProps = {
  cities: CityOutput[];
  cityId: number;
  onCityChange: (value: number) => void;
};

const CitySelector: FC<CitySelectorProps> = ({
  cities,
  cityId,
  onCityChange,
}) => {
  const renderCities = useCallback(() => {
    return map(cities, (city) => (
      <MenuItem key={city.id!} value={city.id!}>
        {city.title}
      </MenuItem>
    ));
  }, [cities]);

  const handleChange = useCallback(
    (event: SelectChangeEvent<typeof cityId>) => {
      const value = event.target.value;

      onCityChange(typeof value === "string" ? parseInt(value) : value);
    },
    [onCityChange]
  );

  return (
    <FormControl fullWidth>
      <Select<typeof cityId>
        id="cities-select"
        value={cityId}
        onChange={handleChange}
      >
        {renderCities()}
      </Select>
    </FormControl>
  );
};

export default memo(CitySelector, isEqual);
